// material
import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import RedirectButton from "../RedirectButton";
import useGetSections from "../../../hooks/portal/useGetSections";

export default function Sell() {
  const { sections } = useGetSections('/secciones/secciones_por_path_estado?path=home&estado=true')

  const theme = useTheme();
  return (
    <Container sx={{ py: { xs: 5, md: 10 } }}>
      {
        sections && sections.length > 0 &&
        <>
          <Box display="block" mx="auto" maxWidth={600} width="100%">
            <Typography
              variant="h2"
              sx={{ mb: 2, textAlign: { xs: "center", md: "start" } }}
            >
              ¿QUIERES VENDER?
            </Typography>

            <Grid container>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "start" },
                  mb: { xs: 3, md: 0 },
                }}
              >
                <Box
                  sx={{
                    boxShadow: "inset 0px 3px 6px #58840A",
                    border: "2px solid #95D329",
                    borderRadius: 100,
                    opacity: 1,
                    height: { xs: 100, md: 150 },
                    width: { xs: 100, md: 150 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={sections[0].Imagen}
                    loading='lazy'
                    width={'100%'}
                    height='100%'
                    style={{ maxHeight: '70px' }}
                    alt={sections[0].ALT}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: { xs: "center", md: "start" } }}
                  >
                    Nos acomodamos a tu necesidad
                  </Typography>
                  <Box sx={{ textAlign: { xs: "center", md: "start" } }}>
                    <Typography variant="caption">
                  <span
                    style={{
                      color: theme.palette.primary.dark,
                    }}
                  >
                    <b>Existen 2 modalidades de venta&nbsp;</b>
                  </span>
                      según la urgencia que tengas:
                    </Typography>
                  </Box>
                  <Paper
                    elevation={2}
                    sx={{ p: 1, my: 1, textAlign: { xs: "center", md: "start" } }}
                  >
                    <Typography variant="subtitle1">
                      Si estás apurado, nosotros te la compramos.
                    </Typography>
                  </Paper>
                  <Paper
                    elevation={2}
                    sx={{ p: 1, textAlign: { xs: "center", md: "start" } }}
                  >
                    <Typography variant="subtitle1">
                      Si no lo estas, nosotros te la publicamos.
                    </Typography>
                  </Paper>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <RedirectButton url='/quieres-vender'/>
          </Box>
        </>
      }
    </Container>
  );
}
